import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=20ad6f01&"
import script from "./CancelButton.vue?vue&type=script&lang=js&"
export * from "./CancelButton.vue?vue&type=script&lang=js&"
import style0 from "./CancelButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports